export default __webpack_public_path__ + "static/space_station-9d5b36e74fb6acbeb47f8f11962b15c4.png";